import React, { useState } from 'react';
import { Input } from '@indigo-ag/component-module';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import i18next from 'core/i18n';

import { EnhancedTable, HeadCell, utils, FinancingBrazilKML } from 'shared';

interface GrowerKMLListProps {
  financingBrazilKMLs: FinancingBrazilKML[];
}

export const GrowerKMLList: React.FunctionComponent<GrowerKMLListProps> = ({ financingBrazilKMLs }) => {
  /**
   * State
   */
  const [searchText, setSearchText] = useState('');

  const updateSearch = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const kmlsHeadCells: HeadCell<FinancingBrazilKML>[] = [
    {
      id: 'documentName',
      label: i18next.t('documentName')
    },
    {
      id: 'documentUrl',
      label: i18next.t('documentUrl')
    },
    {
      id: 'createdAt',
      label: i18next.t('createdAt'),
      mapper: (kml: FinancingBrazilKML) => utils.date.formatDate(kml.createdAt)
    }
  ];

  const filteredKMLs = !searchText
    ? financingBrazilKMLs
    : financingBrazilKMLs.filter(kml => kml.documentName.toLowerCase().includes(searchText));

  return (
    <div style={{ flexDirection: 'column' }}>
      <Input
        label=""
        placeholder={`${i18next.t('filter')} ${i18next.t('documentName')}`}
        sizeVariant="slim"
        onChange={updateSearch}
        faIconBefore={faSearch}
      />
      <EnhancedTable rows={filteredKMLs} headCells={kmlsHeadCells} ignorePaper sort initOrderBy="createdAt" />
    </div>
  );
};
